import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7f6a2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "excercises classgroup" }
const _hoisted_2 = {
  class: "card mb-3",
  id: "contentExercisesTable",
  "data-list": "{'valueNames':['name','email','product','payment','amount'],'page':8,'pagination':true}"
}
const _hoisted_3 = { class: "card-header bg-light" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"color":"#004761"} }, "Assignments", -1))
const _hoisted_7 = { class: "nav-link-icon mx-2 mb-1" }
const _hoisted_8 = {
  ref: "assignamentInfoTooltip",
  class: "fas fa-info-circle icon-info",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: "Teachers can search and assign one or more exercises to a class group with a date range for completion."
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row flex-between-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "aling-middle align-items-center fs--1" }, " Add more than one to the same deadline and they will be all included together for that deadline date. ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = { class: "row flex-between-center" }
const _hoisted_12 = { class: "d-flex flex-md-row justify-content-evenly" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchExercises = _resolveComponent("SearchExercises")!
  const _component_DataTableExercises = _resolveComponent("DataTableExercises")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, null, 512)
            ])
          ])
        ]),
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_SearchExercises, {
              horizontal: "",
              "class-group": _ctx.classGroup,
              onFilter: _ctx.filterExercises
            }, null, 8, ["class-group", "onFilter"])
          ])
        ])
      ]),
      (_ctx.exercises.length > 0)
        ? (_openBlock(), _createBlock(_component_DataTableExercises, {
            key: 0,
            "class-groups": _ctx.classGroups,
            "class-group": _ctx.classGroup,
            exercises: _ctx.exercises,
            pagination: _ctx.pagination,
            onChangePage: _ctx.getExercises
          }, null, 8, ["class-groups", "class-group", "exercises", "pagination", "onChangePage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}